var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":_vm.modalId,"size":"xl","title":_vm.title,"hide-header-close":"","ok-only":""}},[_c('role-legend',{attrs:{"orgId":_vm.orgId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }